import { ONBOARDING_SESSION_ROUTES } from '@/contracts/onboarding-session';
import { env } from '@/lib/env';

/** A brand's icon, read through the BFF: `<img>` asks for it, and a miss falls back to the initial. */
export function competitorIconUrl(sessionId: string, brandId: string): string {
  const path = ONBOARDING_SESSION_ROUTES.competitorIcon
    .replace(':id', encodeURIComponent(sessionId))
    .replace(':brandId', encodeURIComponent(brandId));
  return `${env.bffUrl}${path}`;
}
